import RefNavbar from './RefNavbar';
import RefPartners from './RefPartners';

function Page2026Partners() {
  return (
    <>
      <RefNavbar />
      <RefPartners />
    </>
  );
}

export default Page2026Partners;
